const loadIntlMessages = async (locale: string) => {
    try {
        return await import(`../lang/.compiled-lang/${locale}.json`).then(module => module.default);
    } catch (error) {
        throw new Error('Could not load compiled language files. Please run "npm run i18n:compile" first"');
    }
};

export default loadIntlMessages;
